import { MESSENGER_EVENTS, observeMessengerLoaded } from 'lib/messenger/Messenger';
import { processVerificationQuery } from 'utils/verification';
import { tld } from 'utils/env';
import { getABTestVariant } from 'utils/abtest';
import { initCdn } from 'utils/cdn';
import '@Sklik-aa/fisher';
import 'polyfill/structuredClone';

export function dotInit() {
	const _tld = tld();
	const abtestVariants = getABTestVariant(globalThis.document.cookie);
	const abtest = abtestVariants.join(','); // Join the array back to a comma-separated string for DOT

	globalThis.window.DOT?.cfg({
		service: 'sbazar',
		host: `h.seznam.${_tld}`,
		spa: true, // Due to transitions, for the DOT purposes, the page is SPA
		spenttimeSpaReset: false, // Do not reset spent time when transitioning between pages
		impress: false, // Disable automatic impression sending
		...(abtest && { abtest }),
	});
}

export function clientInit() {
	initCdn();
	processVerificationQuery();

	if (typeof globalThis.window.sssp?.config === 'function') {
		// #if [DEBUG_LOCAL=1]
		globalThis.window.sssp.config({ badge: true, test: true });
		// #else
		globalThis.window.sssp.config({ badge: true });
		// #endif
	}

	observeMessengerLoaded((messenger) => {
		const onRoomShow = () => {
			if (globalThis.window.hj) {
				globalThis.window.hj('event', 'messenger-room-show');
			}
			messenger.removeEventListener(MESSENGER_EVENTS.ROOM_SHOW, onRoomShow);
		};
		messenger.addEventListener(MESSENGER_EVENTS.ROOM_SHOW, onRoomShow);
	});
}
